/**
 * Test if we're running on a local version of Grassroots, meaning our host either canonically points to localhost,
 * the host is quorum.club, or the host is a subdomain of quorum.club. Note unless you override it (either through
 * /etc/hosts or a custom DNS server), quorum.club and subdomains will point to localhost.
 *
 * Be careful with this as (1) it will likely give different behaviour on local environment vs production environments
 * and (2) within Jest, location.host === "localhost" so this will (maybe unexpectedly) return true
 *
 * @param host - the host to check, usually you want to grab this from window.location.host
 * @return {boolean} - true if the host is local, and false otherwise
 */
export function isHostLocal(host) {
    return /^localhost$|^127\.0\.0\.1$|(^|.)quorum\.club$/.test(host)
}
